module.exports = __webpack_public_path__ + "img/P90x2.e68b13b9.jpg";